import { mount } from 'svelte';
import App from './app/App.svelte';
import { bootstrapAuth } from './app/auth/bootstrap';
import { startRouter } from './app/router.svelte';
import './app/app.css';

await bootstrapAuth();

const target = document.getElementById('app');
if (!target) {
  throw new Error('mount target #app not found');
}

startRouter();
mount(App, { target });
